import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  Button,
} from "@mui/material";

type ConfirmSaveDialogProps = {
  confirmationOpen: boolean;
  handleCancelConfirmation: () => void;
  handleConfirmSave: () => void;
};

const ConfirmSaveDialog = ({
  confirmationOpen,
  handleCancelConfirmation,
  handleConfirmSave,
}: ConfirmSaveDialogProps) => {
  return (
    <>
      <Dialog open={confirmationOpen} onClose={handleCancelConfirmation}>
        <DialogTitle>Confirmar Cambios</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro que desea guardar los cambios realizados? Esta acción
            actualizará la información del comercio.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirmation}>Cancelar</Button>
          <Button
            onClick={handleConfirmSave}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmSaveDialog;
